module.exports = __webpack_public_path__ + "img/young-boys-logo-icon.09633bef.png";